import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { InlineWidget } from 'react-calendly';

import GridLayout from '../components/layout/GridLayout';
import Menu from '../components/layout/Menu';
import Card from '../components/ui/Card';

interface BookingPageProps {
  isMenuOpen?: boolean;
}

export default function BookingPage({
  isMenuOpen = false
}: BookingPageProps) {

  // Logic: The react-calendly library handles script injection automatically,
  // so we no longer need the useEffect manual script loading.

  return (
    <GridLayout
      isMenuOpen={isMenuOpen}
      left={<Menu />}

      main={
        <Stack spacing={3}>

          {/* ✅ Main Booking Card */}
          <Card>

            <Typography
              variant="h4"
              sx={{
                color: '#34de9aab',
                fontWeight: 'bold',
                mb: 1
              }}
            >
              Lesson Booking
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 4 }}
            >
              Reserve your online Pilates session
            </Typography>

            {/* ✅ Calendly Embed using react-calendly */}
            <Box
              sx={{
                minWidth: '320px',
                height: '700px',
                borderRadius: 3,
                overflow: 'hidden',
                border: '1px solid #eee'
              }}
            >
              <InlineWidget 
                url="https://calendly.com/niagreenerysomatic" 
                styles={{
                  height: '700px',
                  width: '100%'
                }}
              />
            </Box>

          </Card>

        </Stack>
      }

      right={
        <Stack spacing={2}>

          {/* ✅ Tips */}
          <Card>
            <Typography
              variant="h6"
              sx={{
                color: '#34de9aab',
                mb: 2,
                fontWeight: 'bold'
              }}
            >
              Booking Tips
            </Typography>

            <Typography variant="body2">
              • Book 24h in advance
            </Typography>

            <Typography variant="body2">
              • Zoom link sent automatically
            </Typography>

            <Typography variant="body2">
              • Mobile booking supported
            </Typography>
          </Card>

          {/* ✅ Session Info */}
          <Card>
            <Typography
              variant="h6"
              sx={{
                color: '#34de9aab',
                mb: 2,
                fontWeight: 'bold'
              }}
            >
              Session Types
            </Typography>

            <Typography variant="body2">
              • Beginner Pilates
            </Typography>

            <Typography variant="body2">
              • Rehabilitation Flow
            </Typography>

            <Typography variant="body2">
              • Posture Correction
            </Typography>

            <Typography variant="body2">
              • Private Online Session
            </Typography>
          </Card>

        </Stack>
      }
    />
  );
}